import React, { Dispatch, SetStateAction } from 'react';
import {
  StyleSheet, Text, View, ViewStyle, Pressable,
} from 'react-native';
import Colors from '../../../constants/Colors';
import Style from '../../../constants/Style';
import PressableStyled, { PressableState } from '../../../components/PressableStyled';
import { priorityColor } from '../../../components/Map/SetFloorsModal/FloorItem';
import FlagIcon16 from '../../../components/16pxIcons/FlagIcon16';
import DropdownIcon from '../../../components/16pxIcons/DropdownIcon';

interface PriorityIndicatorProps {
  isHighPriority: boolean,
  setIsHighPriority?: Dispatch<SetStateAction<boolean>>,
  style?: ViewStyle | ViewStyle[],
  priorityDropdownShown?: boolean,
  setPriorityDropdownShown?: Dispatch<SetStateAction<boolean>>,
  testID?: string,
}

const PriorityIndicator = ({
  style, isHighPriority, setIsHighPriority, priorityDropdownShown, setPriorityDropdownShown, testID,
}: PriorityIndicatorProps) => <View {...{ style, testID }}>
    <PressableStyled
      disabled={!setPriorityDropdownShown}
      onPress={() => setPriorityDropdownShown(!priorityDropdownShown)}
      style={[styles.container, { borderColor: priorityColor(isHighPriority) }]}
    >
      <FlagIcon16 color={priorityColor(isHighPriority)} />
      <Text style={[styles.text, { color: priorityColor(isHighPriority) }]}>
        {isHighPriority ? 'High' : 'Normal'}
      </Text>
      {setPriorityDropdownShown && <DropdownIcon
        color={priorityColor(isHighPriority)}
        style={priorityDropdownShown ? Style.inverted : Style.upright}
      />}
    </PressableStyled>
    <View>
      {priorityDropdownShown && <View style={styles.dropdown}>
        <Pressable
          onPress={() => {
            setIsHighPriority(true);
            setPriorityDropdownShown(false);
          }}
          style={({ hovered, pressed }: PressableState) => [
            hovered && Style.listItemHovered, pressed && Style.listItemPressed,
          ]}
        >
          <Text style={[styles.option, isHighPriority && styles.optionSelected]}>{'High'}</Text>
        </Pressable>
        <Pressable
          onPress={() => {
            setIsHighPriority(false);
            setPriorityDropdownShown(false);
          }}
          style={(state: PressableState) => [
            state.hovered && Style.listItemHovered, state.pressed && Style.listItemPressed,
          ]}
        >
          <Text style={[styles.option, !isHighPriority && styles.optionSelected]}>{'Normal'}</Text>
        </Pressable>
      </View>}
    </View>
  </View>;

const styles = StyleSheet.create({
  container: {
    borderWidth: 1.5,
    borderRadius: 4,
    paddingHorizontal: 4,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#FFF',
    opacity: 1,
  },
  text: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'Roboto_500Medium',
    marginHorizontal: 2,
  },
  dropdown: {
    backgroundColor: '#FFF',
    position: 'absolute',
    borderWidth: 1.5,
    borderRadius: 10,
    borderColor: Colors.light.hereworksBlue100,
    overflow: 'hidden',
    end: -1,
    top: 4,
    zIndex: 2,
  },
  option: {
    paddingHorizontal: 12,
    paddingVertical: 9,
    color: Colors.light.hereworksBlack600,
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'Poppins_400Regular',
  },
  optionSelected: {
    backgroundColor: Colors.light.hereworksDarkBlue,
    color: '#FFF',
  },
});

export default PriorityIndicator;
